import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';

/**
 * Features that are switched off in the product but kept in the codebase. Read from here rather
 * than hidden behind `*ngIf="false"` or a commented-out route, so turning one back on is one edit
 * instead of a hunt through routing modules and templates.
 */
export const features = {
  /** Patient interactions: the summary table, the create-interaction button and patient tracking. */
  patientInteractions: false,
  /** Copayment: the referral sub-navigation tab. */
  referralCopayment: false
};

export type FeatureName = keyof typeof features;

export interface FeatureRouteData {
  feature: FeatureName;
  /** Where to send the user when the feature is off. */
  featureDisabledRedirect: string;
}

/** Keeps a switched-off feature's route out of reach while leaving the route itself readable. */
@Injectable({
  providedIn: 'root'
})
export class FeatureEnabledGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot): boolean | UrlTree {
    const data = next.data as FeatureRouteData;

    return features[data.feature] || this.router.parseUrl(data.featureDisabledRedirect);
  }
}
